import { PuzzleTypeIdEnum } from '../puzzle-framework-module/puzzle-type-id.enum';

export class MarkAsRead {
  constructor(public payload: { puzzleTypeId: PuzzleTypeIdEnum }) {}
  static readonly type = '[PuzzleUpdateNotifications] MarkAsRead';
}

export class LoadUpdateNotifications {
  constructor(public payload: { puzzleTypeId: PuzzleTypeIdEnum; language: string }) {}
  static readonly type = '[PuzzleUpdateNotifications] LoadUpdateNotifications';
}
